// import { useParams, useLocation } from "react-router-dom";
// import { useEffect, useState } from "react";
// import CustomToastify, { toastMes } from "../../globalConf/notification";
// import {
//   basicUrl,
//   endPoints,
//   httpNonTokenV2,
// } from "../../globalConf/http-non-token";
// import { convertZipFile } from "../../globalConf/zipping";
// import axios from "axios";
// import { http } from "../../globalConf/http";

// const UploadUrlOrCD = () => {
//   const { uploadToken } = useParams();
//   const { search } = useLocation();
//   const query = new URLSearchParams(search);
//   const typeFromUrl = query.get("type");
//   const patientName = query.get("patient_name");
//   const request_id = query.get("request_id");

//   // console.log(uploadToken);
//   const [typeDicom, setTypeDicom] = useState(null);
//   const [submitting, setSubmitting] = useState(false);
//   const [success, setSuccess] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [canSubmit, setCanSubmit] = useState(false);

//   const [fileName, setFileName] = useState("");

//   //https://admin.qubx3d.com/eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyZXF1ZXN0X2lkIjoyNjg1LCJwYXRpZW50X2lkIjoxNzE3LCJkaWNvbV9zb3VyY2VfaWQiOjMsInBhdGllbnRfbmFtZSI6IkFub255bW91c181NDAzIiwiZXhwIjoxNzU5OTU5NTgwfQ.1NL0q7I4Ypi0U5vP215eBSFhwpsqBF9YHN_SBZumCNQ?type=CD&patient_name=Anonymous_5403
//   const [request, setRequest] = useState(null);
//   const [loadingRequest, setLoadingRequest] = useState(true);

//   useEffect(() => {
//     const fetchRequestData = async () => {
//       try {
//         const res = await http.get(`${endPoints.request}/${request_id}`);
//         setRequest(res.data);
//       } catch (error) {
//         console.error("Error fetching request:", error);
//       } finally {
//         setLoadingRequest(false);
//       }
//     };

//     fetchRequestData();
//   }, [uploadToken]);

//   const [fileUploaded, setFileUploaded] = useState(false);

//   useEffect(() => {
//     setTypeDicom(typeFromUrl);
//   }, [uploadToken, typeFromUrl]);
//   const handleInputChange = (e) => {
//     if (typeDicom === "URL") {
//       setCanSubmit(!!e?.target?.value?.trim());
//     } else {
//       const files = e.target?.files;
//       if (files && files.length > 0) {
//         setFileName(files[0].name);
//         setCanSubmit(true);
//       } else {
//         setFileName("");
//         setCanSubmit(false);
//       }
//     }
//   };

//   const [isDragging, setIsDragging] = useState(false);

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setIsDragging(true);
//   };

//   const handleDragLeave = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setIsDragging(false);
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setIsDragging(false);
//     const files = e.dataTransfer.files;
//     if (files && files.length > 0) {
//       const fileInput = document.querySelector('input[name="uploadFile"]');
//       if (fileInput) {
//         fileInput.files = files;
//         // Trigger change manually since setting .files doesn't fire onChange
//         const event = { target: fileInput };
//         handleInputChange(event);
//       }
//     }
//   };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   const form = e.currentTarget;

//   //   try {
//   //     setSubmitting(true);
//   //     setProgress(0);
//   //     if (typeDicom === "URL") {
//   //       const url = new FormData(form).get("uploadUrl");
//   //       await httpNonTokenV2.patch(
//   //         // await axios.patch(
//   //         // `https://socially-comic-stork.ngrok-free.app/api/v2
//   //         `/requests/dicom-patch/?token=${uploadToken}`,
//   //         { DICON_URL: url },
//   //         {
//   //           headers: {
//   //             "Content-Type": "application/json",
//   //           },
//   //         }
//   //       );
//   //       setSuccess(true);
//   //       toastMes.success("URL uploaded successfully");
//   //     }

//   //     setSuccess(true);
//   //     form.reset();
//   //     setCanSubmit(false);
//   //     setProgress(0);
//   //   } catch (err) {
//   //     setSuccess(false);

//   //     const errorMsg =
//   //       err.response?.data?.detail ||
//   //       err.message ||
//   //       "Unexpected error occurred";

//   //     toastMes.error(errorMsg);
//   //     form.reset();
//   //     setCanSubmit(false);
//   //     setProgress(0);
//   //   } finally {
//   //     setSubmitting(false);
//   //   }
//   // };
//   // else if (typeDicom === "CD") {
//   //         const file = new FormData();
//   //         file.append("DICON_File", form.uploadFile.files[0]);

//   //         await httpNonTokenV2.patch(
//   //           `/requests/dicom-patch/?token=${uploadToken}`,
//   //           // await axios.patch(
//   //           //   `https://socially-comic-stork.ngrok-free.app/api/v2/requests/dicom-patch/?token=${uploadToken}`,

//   //           file,
//   //           {
//   //             onUploadProgress: (progressEvent) => {
//   //               const percent = Math.round(
//   //                 (progressEvent.loaded * 100) / (progressEvent.total || 1)
//   //               );
//   //               setProgress(percent);
//   //             },
//   //           }
//   //         );

//   //         toastMes.success(" File Uploaded successfully");
//   //       }

//   // if (!typeDicom) return null;
//   // return (
//   //   <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
//   //     <form
//   //       onSubmit={handleSubmit}
//   //       className="bg-white shadow rounded p-4"
//   //       style={{ width: 380 }}
//   //     >
//   //       <h2 className="h5 text-center mb-4">
//   //         {typeDicom === "URL" ? "Upload URL" : "Upload CD"}
//   //       </h2>
//   //       {typeDicom === "URL" ? (
//   //         <div className="mb-3">
//   //           <input
//   //             type="url"
//   //             name="uploadUrl"
//   //             placeholder="Enter DICOM URL"
//   //             required
//   //             onChange={handleInputChange}
//   //             className="form-control"
//   //           />
//   //         </div>
//   //       ) : (
//   //         <div className="mb-3">
//   //           <input
//   //             type="file"
//   //             name="uploadFile"
//   //             required
//   //             onChange={handleInputChange}
//   //             className="form-control"
//   //           />
//   //           <div className="form-text">
//   //             Allowed: .dcm (single) or .zip (multiple DICOMs)
//   //           </div>
//   //         </div>
//   //       )}
//   //       {/* Progress Bar */}
//   //       {typeDicom !== "URL" && submitting && (
//   //         <div className="progress mb-3" style={{ height: "6px" }}>
//   //           <div
//   //             className="progress-bar"
//   //             role="progressbar"
//   //             style={{ width: `${progress}%` }}
//   //           ></div>
//   //         </div>
//   //       )}

//   //       {/*
//   //       <button
//   //         type="submit"
//   //         className="btn btn-primary w-100"
//   //         disabled={submitting}
//   //       >
//   //         {submitting ? "Uploading..." : "Submit"}
//   //       </button> */}
//   //       <button
//   //         type="submit"
//   //         className="btn btn-primary w-100"
//   //         disabled={!canSubmit || submitting}
//   //       >
//   //         {submitting
//   //           ? typeDicom === "URL"
//   //             ? "Loading..."
//   //             : `Uploading... ${progress}%`
//   //           : "Submit"}
//   //       </button>

//   //       <CustomToastify bgColor={success ? "green" : "red"} duration={5000} />
//   //     </form>
//   //   </div>
//   // );

//   // //chunked upload
//   // const uploadSingleChunk = async ({
//   //   requestId,
//   //   chunk,
//   //   chunkIndex,
//   //   totalChunks,
//   //   fileName,
//   //   uploadId,
//   //   uploadedBytes,
//   //   targetField,
//   // }) => {
//   //   const formData = new FormData();
//   //   formData.append("chunk", chunk);
//   //   formData.append("chunk_index", chunkIndex);
//   //   formData.append("total_chunks", totalChunks);
//   //   formData.append("filename", fileName);
//   //   formData.append("target_field", targetField);

//   //   if (uploadId) {
//   //     formData.append("upload_id", uploadId);
//   //   }

//   //   const response = await axios.post(
//   //     `${basicUrl}/request/${requestId}/chunked-upload/`,
//   //     formData,
//   //     {
//   //       onUploadProgress: (e) => {
//   //         if (!e.total) return;

//   //         const overallUploaded = uploadedBytes + e.loaded;
//   //         const percent = Math.min(
//   //           Math.round((overallUploaded / (uploadedBytes + chunk.size)) * 100),
//   //           100,
//   //         );

//   //         setProgress(percent);
//   //       },
//   //     },
//   //   );

//   //   return response.data;
//   // };

//   // const uploadFileChunked = async (
//   //   requestId,
//   //   file,
//   //   targetField = "DICON_File",
//   // ) => {
//   //   const CHUNK_SIZE = 5 * 1024 * 1024;
//   //   const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

//   //   let uploadId = null;
//   //   let uploadedBytes = 0;

//   //   for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
//   //     const start = chunkIndex * CHUNK_SIZE;
//   //     const end = Math.min(start + CHUNK_SIZE, file.size);
//   //     const chunk = file.slice(start, end);

//   //     const data = await uploadSingleChunk({
//   //       requestId,
//   //       chunk,
//   //       chunkIndex,
//   //       totalChunks,
//   //       fileName: file.name,
//   //       uploadId,
//   //       uploadedBytes,
//   //       targetField,
//   //     });

//   //     if (!uploadId && data.upload_id) {
//   //       uploadId = data.upload_id;
//   //     }

//   //     uploadedBytes += chunk.size;
//   //   }

//   //   setProgress(100);
//   // };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   const form = e.currentTarget;

//   //   try {
//   //     setSubmitting(true);
//   //     setProgress(0);

//   //     if (typeDicom === "URL") {
//   //       const url = new FormData(form).get("uploadUrl");
//   //       await httpNonTokenV2.patch(
//   //         `/requests/dicom-patch/?token=${uploadToken}`,
//   //         { DICON_URL: url },
//   //         { headers: { "Content-Type": "application/json" } },
//   //       );
//   //       setSuccess(true);
//   //       toastMes.success("URL uploaded successfully");
//   //     } else if (typeDicom === "CD") {
//   //       const files = form.uploadFile.files;
//   //       if (!files || files.length === 0) {
//   //         toastMes.error("Please select a file");
//   //       }
//   //       const zippedFile = await convertZipFile(files);
//   //       const data = new FormData();
//   //       data.append("DICON_File", zippedFile, `request-${request.id}.zip`);
//   //       data.append("statu", 3);
//   //       // await axios.put(`${basicUrl}/request/update/${request.id}`, data, {
//   //       //   onUploadProgress: (e) => {
//   //       //     const percent = Math.round((e.loaded * 100) / (e.total || 1));
//   //       //     setProgress(percent);
//   //       //   },
//   //       // });
//   //       await uploadFileChunked(request.id, zippedFile);
//   //       // toastMes.success("File uploaded successfully");
//   //     }

//   //     setFileUploaded(true);
//   //     setFileName("");
//   //     form.reset();
//   //     setCanSubmit(false);
//   //     toastMes.success("File uploaded successfully");
//   //   } catch (err) {
//   //     let errorMessage = "Upload failed";

//   //     if (err.response?.data) {
//   //       if (Array.isArray(err.response.data.error)) {
//   //         errorMessage = err.response.data.error.join(" - ");
//   //       } else if (typeof err.response.data.error === "string") {
//   //         errorMessage = err.response.data.error;
//   //       } else if (err.response.data.detail) {
//   //         errorMessage = err.response.data.detail;
//   //       }
//   //     }

//   //     toastMes.error(errorMessage);
//   //   } finally {
//   //     setSubmitting(false);
//   //   }
//   // };

//   // Upload a single chunk
// const uploadSingleChunk = async ({
//   requestId,
//   chunk,
//   chunkIndex,
//   totalChunks,
//   originalFileName, // string from the original File
//   uploadId,
//   uploadedBytes,
//   targetField,
// }) => {
//   const formData = new FormData();
//   formData.append("chunk", chunk);
//   formData.append("chunk_index", chunkIndex);
//   formData.append("total_chunks", totalChunks);
//   formData.append("filename", originalFileName); // always string
//   formData.append("target_field", targetField);

//   if (uploadId) {
//     formData.append("upload_id", uploadId);
//   }

//   // DEBUG: log what’s being sent
//   console.log(
//     `Uploading chunk ${chunkIndex + 1}/${totalChunks} for file:`,
//     originalFileName,
//     "chunk size:", chunk.size,
//     "upload_id:", uploadId
//   );

//   const response = await axios.post(
//     `${basicUrl}/request/${requestId}/chunked-upload/`,
//     formData,
//     {
//       onUploadProgress: (e) => {
//         if (!e.total) return;

//         // overall uploaded so far + current chunk progress
//         const overallUploaded = uploadedBytes + e.loaded;
//         const percent = Math.min(
//           Math.round((overallUploaded / (uploadedBytes + chunk.size)) * 100),
//           100
//         );
//         setProgress(percent);
//       },
//     }
//   );

//   return response.data;
// };

// // Upload a file in chunks
// const uploadFileChunked = async (requestId, file, targetField = "DICON_File",fileNameToUse) => {
//   const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB per chunk
//   const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

//   let uploadId = null;
//   let uploadedBytes = 0;

//   for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
//     const start = chunkIndex * CHUNK_SIZE;
//     const end = Math.min(start + CHUNK_SIZE, file.size);
//     const chunk = file.slice(start, end);

//     const data = await uploadSingleChunk({
//       requestId,
//       chunk,
//       chunkIndex,
//       totalChunks,
//       originalFileName: fileNameToUse,
//       uploadId,
//       uploadedBytes,
//       targetField,
//     });

//     if (!uploadId && data.upload_id) {
//       uploadId = data.upload_id; // store upload session id
//     }

//     uploadedBytes += chunk.size;
//   }

//   setProgress(100); // complete
// };

// // Submit handler
// const handleSubmit = async (e) => {
//   e.preventDefault();
//   const form = e.currentTarget;

//   try {
//     setSubmitting(true);
//     setProgress(0);

//     if (typeDicom === "URL") {
//       const url = new FormData(form).get("uploadUrl");
//       await httpNonTokenV2.patch(
//         `/requests/dicom-patch/?token=${uploadToken}`,
//         { DICON_URL: url },
//         { headers: { "Content-Type": "application/json" } }
//       );
//       toastMes.success("URL uploaded successfully");
//     } else if (typeDicom === "CD") {
//       const files = form.uploadFile.files;
//       if (!files || files.length === 0) {
//         toastMes.error("Please select a file");
//         return;
//       }

//       // compress into zip if needed
//       const zippedFile = await convertZipFile(files);
//       const fileNameToUse = `request-${request.id}.zip`;
//       // upload in chunks
//       await uploadFileChunked(request.id, zippedFile, fileNameToUse);

//       toastMes.success("File uploaded successfully");
//     }

//     setFileUploaded(true);
//     setFileName("");
//     form.reset();
//     setCanSubmit(false);
//   } catch (err) {
//     let errorMessage = "Upload failed";

//     if (err.response?.data) {
//       if (Array.isArray(err.response.data.error)) {
//         errorMessage = err.response.data.error.join(" - ");
//       } else if (typeof err.response.data.error === "string") {
//         errorMessage = err.response.data.error;
//       } else if (err.response.data.detail) {
//         errorMessage = err.response.data.detail;
//       }
//     }

//     toastMes.error(errorMessage);
//   } finally {
//     setSubmitting(false);
//   }
// };

//   if (!typeDicom) return null;

//   return (
//     <div
//       className="d-flex justify-content-center align-items-center min-vh-100"
//       style={{
//         background: "linear-gradient(135deg, #96a2b5ff, #ffffffff)",
//       }}
//     >
//       <form
//         onSubmit={handleSubmit}
//         className="rounded-4 p-4 position-relative"
//         style={{
//           width: 450,
//           background: "rgba(255, 255, 255, 0.93)",

//           border: "1px solid rgba(255, 255, 255, 0.25)",
//           boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
//           transition: "all 0.3s ease",
//         }}
//       >
//         {patientName && (
//           <div className="text-center mb-4">
//             <h5
//               className="fw-bold mb-1"
//               style={{ color: "#000000ff", letterSpacing: "0.5px" }}
//             >
//               Patient
//             </h5>
//             <p
//               className="fw-semibold fs-5"
//               style={{
//                 color: "#32373bff",
//                 marginBottom: 0,
//                 textTransform: "capitalize",
//               }}
//             >
//               {patientName}
//             </p>
//           </div>
//         )}

//         <div className="text-center mb-4">
//           <h2
//             className="fw-bold"
//             style={{
//               color: "#000000ff",
//               fontSize: "1.5rem",
//               letterSpacing: "0.5px",
//             }}
//           >
//             {typeDicom === "URL" ? "Upload DICOM URL" : "Upload DICOM File"}
//           </h2>
//           <p
//             className="small mb-0"
//             style={{ color: "#32373bff", fontWeight: 300 }}
//           >
//             {typeDicom === "URL"
//               ? "Paste the URL of the DICOM file below"
//               : "Select DICOM file to compress and upload"}
//           </p>
//         </div>

//         {request?.DICON_File ||
//         request?.DICON_URL ||
//         request?.result_URL ||
//         fileUploaded ? (
//           <div className="text-center p-4 bg-success bg-opacity-10 rounded-4 border border-success border-opacity-25 mb-3">
//             <i
//               className="bi bi-check-circle-fill text-success mb-2"
//               style={{ fontSize: "3rem" }}
//             ></i>
//             <h4 className="text-success fw-bold">Success!</h4>
//             <p className="text-muted mb-0">
//               The file has been uploaded successfully.
//             </p>
//           </div>
//         ) : (
//           <>
//             {typeDicom === "URL" ? (
//               <div className="mb-3">
//                 <input
//                   type="url"
//                   name="uploadUrl"
//                   placeholder="Enter DICOM URL..."
//                   required
//                   onChange={handleInputChange}
//                   className="form-control form-control-lg rounded-pill shadow-sm"
//                   style={{
//                     background: "rgba(255,255,255,0.1)",
//                     color: "#3d3838ff",
//                     border: "1px solid rgba(255,255,255,0.4)",
//                     fontSize: "0.95rem",
//                   }}
//                 />
//               </div>
//             ) : (
//               <div className="mb-3">
//                 <div
//                   className="p-4 border border-2 border-dashed rounded-4 text-center"
//                   style={{
//                     borderColor: isDragging ? "#445567ff" : "rgba(0,0,0,0.1)",
//                     cursor: "pointer",
//                     background: isDragging
//                       ? "rgba(68, 85, 103, 0.05)"
//                       : "rgba(255, 255, 255, 0.05)",
//                     color: "#1c1818ff",
//                     transition: "all 0.3s ease",
//                     borderStyle: "dashed",
//                   }}
//                   onDragOver={handleDragOver}
//                   onDragLeave={handleDragLeave}
//                   onDrop={handleDrop}
//                   onClick={() =>
//                     document.querySelector('input[name="uploadFile"]').click()
//                   }
//                 >
//                   <i
//                     className="bi bi-cloud-arrow-up mb-2"
//                     style={{ fontSize: "2.5rem", color: "#3a3d40ff" }}
//                   ></i>

//                   {!fileName && (
//                     <p className="mb-1 fw-semibold">Click or drop files here</p>
//                   )}

//                   {fileName && (
//                     <p className="mb-1 fw-semibold text-success">{fileName}</p>
//                   )}
//                 </div>

//                 <input
//                   type="file"
//                   name="uploadFile"
//                   hidden
//                   required
//                   onChange={handleInputChange}
//                 />
//               </div>
//             )}

//             {typeDicom !== "URL" && submitting && (
//               <div
//                 className="progress mb-3"
//                 style={{
//                   height: "8px",
//                   borderRadius: "4px",
//                   overflow: "hidden",
//                   backgroundColor: "rgba(255,255,255,0.2)",
//                 }}
//               >
//                 <div
//                   className="progress-bar progress-bar-striped progress-bar-animated"
//                   role="progressbar"
//                   style={{
//                     width: `${progress}%`,
//                     backgroundColor: "#57cf89",
//                   }}
//                 ></div>
//               </div>
//             )}

//             <button
//               type="submit"
//               className="btn w-100 rounded-pill py-2 fw-semibold shadow-sm"
//               style={{
//                 backgroundColor: "#445567ff",
//                 border: "none",
//                 color: "#fff",
//                 fontSize: "1rem",
//               }}
//               disabled={
//                 loadingRequest ||
//                 !canSubmit ||
//                 submitting ||
//                 request?.statu?.id !== 2
//               }
//             >
//               {loadingRequest
//                 ? "Loading..."
//                 : submitting
//                   ? `Uploading... ${progress}%`
//                   : "Upload"}
//             </button>
//           </>
//         )}

//         <div className="mt-3 text-center">
//           <CustomToastify bgColor={success ? "green" : "red"} duration={5000} />
//         </div>
//       </form>
//     </div>
//   );
// };

// export default UploadUrlOrCD;

import { useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import CustomToastify, { toastMes } from "../../globalConf/notification";
import {
  basicUrl,
  endPoints,
  httpNonTokenV2,
  httpNonToken,
} from "../../globalConf/http-non-token";
import { convertZipFile } from "../../globalConf/zipping";
import axios from "axios";
import { http } from "../../globalConf/http";

const UploadUrlOrCD = () => {
  const { uploadToken } = useParams();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const typeFromUrl = query.get("type");
  const patientName = query.get("patient_name");
  const request_id = query.get("request_id");

  const [typeDicom, setTypeDicom] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [progress, setProgress] = useState(0);
  const [canSubmit, setCanSubmit] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileUploaded, setFileUploaded] = useState(false);
  const [request, setRequest] = useState(null);
  const [loadingRequest, setLoadingRequest] = useState(true);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    setTypeDicom(typeFromUrl);
  }, [uploadToken, typeFromUrl]);

  useEffect(() => {
    const fetchRequestData = async () => {
      try {
        // Use httpNonToken to fetch without login auth token
        const res = await httpNonToken.get(
          `${endPoints.request}/${request_id}`,
        );
        setRequest(res.data);
      } catch (err) {
        console.error("Error fetching request:", err);
      } finally {
        setLoadingRequest(false);
      }
    };
    if (request_id) {
      fetchRequestData();
    } else {
      setLoadingRequest(false);
    }
  }, [uploadToken, request_id]);

  // Handle input change
  const handleInputChange = (e) => {
    if (typeDicom === "URL") {
      setCanSubmit(!!e?.target?.value?.trim());
    } else {
      const files = e.target?.files;
      if (files && files.length > 0) {
        setFileName(files[0].name);
        setCanSubmit(true);
      } else {
        setFileName("");
        setCanSubmit(false);
      }
    }
  };

  // Drag & drop handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      const fileInput = document.querySelector('input[name="uploadFile"]');
      if (fileInput) {
        fileInput.files = files;
        handleInputChange({ target: fileInput });
      }
    }
  };

  // Upload a single chunk
  const uploadSingleChunk = async ({
    requestId,
    chunk,
    chunkIndex,
    totalChunks,
    originalFileName,
    uploadId,
    uploadedBytes,
    targetField,
    totalFileSize,
  }) => {
    const formData = new FormData();
    formData.append("chunk", chunk);
    formData.append("chunk_index", chunkIndex);
    formData.append("total_chunks", totalChunks);
    formData.append("filename", originalFileName);
    formData.append("target_field", targetField);
    if (uploadId) formData.append("upload_id", uploadId);

    console.log(
      `Uploading chunk ${chunkIndex + 1}/${totalChunks} for file:`,
      originalFileName,
      "chunk size:",
      chunk.size,
      "upload_id:",
      uploadId,
    );

    const response = await axios.post(
      `${basicUrl}/request/${requestId}/chunked-upload/`,
      formData,
      {
        onUploadProgress: (e) => {
          if (!e.total) return;
          const percent = Math.round(
            ((uploadedBytes + e.loaded) / totalFileSize) * 100,
          );

          setProgress(percent);
        },
      },
    );

    return response.data;
  };

  // Upload file in chunks
  const uploadFileChunked = async (
    requestId,
    file,
    targetField = "DICON_File",
    originalFileName,
  ) => {
    const CHUNK_SIZE = 5 * 1024 * 1024;
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

    let uploadId = null;
    let uploadedBytes = 0;

    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      const start = chunkIndex * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunk = file.slice(start, end);

      const data = await uploadSingleChunk({
        requestId,
        chunk,
        chunkIndex,
        totalChunks,
        originalFileName,
        uploadId,
        uploadedBytes,
        targetField,
        totalFileSize: file.size,
      });

      if (!uploadId && data.upload_id) uploadId = data.upload_id;
      uploadedBytes += chunk.size;
    }

    setProgress(100);
  };

  // Form submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    try {
      setSubmitting(true);
      setProgress(0);

      if (typeDicom === "URL") {
        const url = new FormData(form).get("uploadUrl");
        await httpNonTokenV2.patch(
          `/requests/dicom-patch/?token=${uploadToken}`,
          { DICON_URL: url },
          { headers: { "Content-Type": "application/json" } },
        );
        toastMes.success("URL uploaded successfully");
      } else if (typeDicom === "CD") {
        const files = form.uploadFile.files;
        if (!files || files.length === 0) {
          toastMes.error("Please select a file");
          return;
        }

        const zippedFile = await convertZipFile(
          files,
          "dicom",
          `request-${request.id}.zip`,
        );
        const originalFileName = `request-${request.id}.zip`;

        await uploadFileChunked(
          request.id,
          zippedFile,
          "DICON_File",
          originalFileName,
        );

        toastMes.success("File uploaded successfully");
      }

      setFileUploaded(true);
      setFileName("");
      form.reset();
      setCanSubmit(false);
    } catch (err) {
      let errorMessage = "Upload failed";
      if (err.response?.data) {
        if (Array.isArray(err.response.data.error)) {
          errorMessage = err.response.data.error.join(" - ");
        } else if (typeof err.response.data.error === "string") {
          errorMessage = err.response.data.error;
        } else if (err.response.data.detail) {
          errorMessage = err.response.data.detail;
        }
      }
      toastMes.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  if (!typeDicom) return null;

  return (
    <div
      className="d-flex justify-content-center align-items-center min-vh-100"
      style={{ background: "linear-gradient(135deg, #96a2b5ff, #ffffffff)" }}
    >
      <form
        onSubmit={handleSubmit}
        className="rounded-4 p-4 position-relative"
        style={{
          width: 450,
          background: "rgba(255, 255, 255, 0.93)",
          border: "1px solid rgba(255, 255, 255, 0.25)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
          transition: "all 0.3s ease",
        }}
      >
        {patientName && (
          <div className="text-center mb-4">
            <h5
              className="fw-bold mb-1"
              style={{ color: "#000000ff", letterSpacing: "0.5px" }}
            >
              Patient
            </h5>
            <p
              className="fw-semibold fs-5"
              style={{
                color: "#32373bff",
                marginBottom: 0,
                textTransform: "capitalize",
              }}
            >
              {patientName}
            </p>
          </div>
        )}

        <div className="text-center mb-4">
          <h2
            className="fw-bold"
            style={{
              color: "#000000ff",
              fontSize: "1.5rem",
              letterSpacing: "0.5px",
            }}
          >
            {typeDicom === "URL" ? "Upload DICOM URL" : "Upload DICOM File"}
          </h2>
          <p
            className="small mb-0"
            style={{ color: "#32373bff", fontWeight: 300 }}
          >
            {typeDicom === "URL"
              ? "Paste the URL of the DICOM file below"
              : "Select DICOM file to compress and upload"}
          </p>
        </div>

        {request?.DICON_File ||
        request?.DICON_URL ||
        request?.result_URL ||
        fileUploaded ? (
          <div className="text-center p-4 bg-success bg-opacity-10 rounded-4 border border-success border-opacity-25 mb-3">
            <i
              className="bi bi-check-circle-fill text-success mb-2"
              style={{ fontSize: "3rem" }}
            ></i>
            <h4 className="text-success fw-bold">Success!</h4>
            <p className="text-muted mb-0">
              The file has been uploaded successfully.
            </p>
          </div>
        ) : (
          <>
            {typeDicom === "URL" ? (
              <input
                type="url"
                name="uploadUrl"
                placeholder="Enter DICOM URL..."
                required
                onChange={handleInputChange}
                className="form-control form-control-lg rounded-pill shadow-sm mb-3"
                style={{
                  background: "rgba(255,255,255,0.1)",
                  color: "#3d3838ff",
                  border: "1px solid rgba(255,255,255,0.4)",
                  fontSize: "0.95rem",
                }}
              />
            ) : (
              <div className="mb-3">
                <div
                  className="p-4 border border-2 border-dashed rounded-4 text-center"
                  style={{
                    borderColor: isDragging ? "#445567ff" : "rgba(0,0,0,0.1)",
                    cursor: "pointer",
                    background: isDragging
                      ? "rgba(68, 85, 103, 0.05)"
                      : "rgba(255, 255, 255, 0.05)",
                    color: "#1c1818ff",
                    transition: "all 0.3s ease",
                  }}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                  onClick={() =>
                    document.querySelector('input[name="uploadFile"]').click()
                  }
                >
                  <i
                    className="bi bi-cloud-arrow-up mb-2"
                    style={{ fontSize: "2.5rem", color: "#3a3d40ff" }}
                  ></i>
                  {!fileName ? (
                    <p className="mb-1 fw-semibold">Click or drop files here</p>
                  ) : (
                    <p className="mb-1 fw-semibold text-success">{fileName}</p>
                  )}
                </div>
                <input
                  type="file"
                  name="uploadFile"
                  hidden
                  required
                  onChange={handleInputChange}
                />
              </div>
            )}

            {typeDicom !== "URL" && submitting && (
              <div
                className="progress mb-3"
                style={{
                  height: "8px",
                  borderRadius: "4px",
                  overflow: "hidden",
                  backgroundColor: "rgba(255,255,255,0.2)",
                }}
              >
                <div
                  className="progress-bar progress-bar-striped progress-bar-animated"
                  role="progressbar"
                  style={{ width: `${progress}%`, backgroundColor: "#57cf89" }}
                ></div>
              </div>
            )}

            <button
              type="submit"
              className="btn w-100 rounded-pill py-2 fw-semibold shadow-sm"
              style={{
                backgroundColor: "#445567ff",
                border: "none",
                color: "#fff",
                fontSize: "1rem",
              }}
              disabled={
                loadingRequest ||
                !canSubmit ||
                submitting ||
                request?.statu?.id !== 2
              }
            >
              {loadingRequest
                ? "Loading..."
                : submitting
                  ? `Uploading... ${progress}%`
                  : "Upload"}
            </button>
          </>
        )}

        <div className="mt-3 text-center">
          <CustomToastify bgColor={success ? "green" : "red"} duration={5000} />
        </div>
      </form>
    </div>
  );
};

export default UploadUrlOrCD;
